// extracted by mini-css-extract-plugin
export default {"component":"check-box__k4AR5","checkbox":"check-box__PJURV","filterName":"check-box__BUVSo","chklabel":"check-box__s202s","filter":"check-box__Lcdmh"};